module.exports = __webpack_public_path__ + "img/SN.ca5bb07f.svg";